import { labelForValueInLookup, formatDate, formatDateTime, updateAllProperties, formatPhoneNumber } from '@/utils/utils'
import store from '@/state/store'

export default class Offer {
  constructor (values) {
    updateAllProperties(this, values)
    //console.log('Offer constructor:', JSON.stringify(this))
  }

  get dateCreatedFormatted () {return formatDateTime(this.dateCreated)}
  get dateCreatedDateOnlyFormatted () {return formatDate(this.dateCreated)}

  get grainLabel () {return labelForValueInLookup(this.grain, store.state.lookup.grain)}
  get gradeLabel () {
    const grade = labelForValueInLookup(this.grade, store.getters['lookup/grades'](this.grain)) || ''
    const gradeParts = grade.split(' - ')
    return gradeParts.length > 1 ? gradeParts[1] : grade
  }

  getLot(){ return this.lot ? this.lot.trim().substring(0, 6) :'' }
  get seasonLabel () {return labelForValueInLookup(this.season, store.state.lookup.season)}
  get storageTypeLabel () {return labelForValueInLookup(this.storageType, store.state.lookup.storageType)}
  get offerTypeLabel () {return labelForValueInLookup(this.offerType, store.state.lookup.offerType)}
  get paymentTermLabel () {return labelForValueInLookup(this.paymentTerm, store.state.lookup.paymentTerm)}
  get pricingMethodLabel () {
    const pricingMethod = this.pricingMethod || (this.storageType === 'ON_FARM' ? 'EX_FARM' : 'WAREHOUSE_TRANSFER')
    return labelForValueInLookup(pricingMethod, store.state.lookup.pricingMethod)
  }

  //set quantity (value) {this.quantity = value}
  set quantityRemaining (value) {this.remainingQuantity = value}
  //set farmLocation (value) {this.farmStorageLocation = value}
  get priceLabel () {return '$' + this.price }
  get quantityRemaining () {return this.remainingQuantity === undefined || this.remainingQuantity === null ? this.quantity : this.remainingQuantity }
  //get farmLocation () {return this.farmStorageLocation}
  get quantityRemainingLabel () {return this.quantityRemaining + ' mt' }
  get offerLabel () {return this.quantityRemaining + 'mt @ $' + this.price + '/mt'}

  get accountManagerName () {return (this.accountManager?.firstName || '') + ' ' + (this.accountManager?.lastName || '')}
  get accountManagerEmail () {return this.accountManager?.email}
  get accountManagerPhone () {return this.accountManager?.phone}
  get accountManagerPhoneLabel () {return formatPhoneNumber(this.accountManager?.phone)}

  

  get locatedLabel () {
    return this.located(false)
  }
  get shortLocatedLabel () {
    return this.located(false, false)
  }
  located (includeRegion = true, includeFacility = true) {
    let located = ''
    //console.log('offer region:', this.region)
    if (this.storageType === 'WAREHOUSE') {
      const warehouseLocation = store.state.lookup.warehouseLocation.filter(item => item.name === this.warehouseLocation)?.[0] || {}
      located = (includeFacility ? warehouseLocation.provider?.displayName + ', ' : '') + 
        (warehouseLocation.city ? warehouseLocation.city : (warehouseLocation.displayName || '').split(' (')[0]) + ' ' + 
        (includeRegion && warehouseLocation.region?.name !== 'UNKNOWN' ? warehouseLocation.region?.displayName + ' ' : '') + 
        warehouseLocation.state?.displayName
    } else if (this.storageType === 'ON_FARM') {
      let nearestTown = ''
      if(this.nearestTownDistance !== null && this.nearestTownDirection !== null){
        nearestTown = this.nearestTownDistance + 'km ' + this.nearestTownDirection + ' of '
      }
      located = (includeFacility ? 'On farm, ' : '') + nearestTown + this.farmLocation?.city + ', ' + 
        (includeRegion ? labelForValueInLookup(this.region, store.getters['lookup/regions'](this.state)) + ' ' : '') + 
        (this.farmLocation?.state || this.state)
    }
    return located
  }

  static sanitiseModel (input) {
    const offer = JSON.parse(JSON.stringify(input))   
    if (offer.pesticideFree === true) {
      delete offer.treatmentDetail
    }
    if (offer.storageType === 'ON_FARM') {
      //if (offer.meetsGTAStandard === true) {
      // delete offer.ticketDetail
      //} else  {
      if(!offer.ticketDetail.protein)
      {
        delete offer.ticketDetail.protein
      }
      if(!offer.ticketDetail.screenings)
      {
        delete offer.ticketDetail.screenings
      }
      if(!offer.ticketDetail.moisture)
      {
        delete offer.ticketDetail.moisture
      }
      if(!offer.ticketDetail.weight)
      {
        delete offer.ticketDetail.weight
      }

      if (offer.grain !== 'CANOLA') {
        delete offer.ticketDetail.oil
      }
      
      //}        
    } else {
      delete offer.meetsGTAStandard
      delete offer.ticketDetail
      delete offer.farmStorageType
      delete offer.farmLocation
    }
    if (offer.storageType === 'WAREHOUSE') {
      // Any required transforms go here...
    } else {
      delete offer.warehouseProvider
      delete offer.warehouseLocation
    }
    if (offer.offerType === 'INDICATIVE') {
      delete offer.firmOfferExpiry
    }
  
    return offer
  } 

  static setClass (obj) {
    if (obj instanceof Object !== true) return

    // TODO: Remove this temp workaround once the backend bug is fixed
    obj.storageType = obj.storageType.toUpperCase().replaceAll(' ', '_')
    obj.offerType = obj.offerType.toUpperCase().replaceAll(' ', '_')
    
    if (obj.datePreferredPickupStart) {
      const utcDate = new Date(obj.datePreferredPickupStart);
      const localDate = new Date(utcDate.getTime() - (utcDate.getTimezoneOffset() * 60000));
      obj.datePreferredPickupStart = localDate.toISOString();
      //console.log('datePreferredPickupStart:', obj.datePreferredPickupStart)
    }

    if (obj.datePreferredPickupEnd) {
      const utcDate = new Date(obj.datePreferredPickupEnd);
      const localDate = new Date(utcDate.getTime() - (utcDate.getTimezoneOffset() * 60000));
      obj.datePreferredPickupEnd = localDate.toISOString();
      console.log('datePreferredPickupEnd:', obj.datePreferredPickupEnd)
    }
    Object.setPrototypeOf(obj, Offer.prototype)
    return obj
  }
  static setClasses (objs) {
    objs.forEach(obj => Offer.setClass(obj))
    return objs
  }
  static copy (obj) {
    const copy = JSON.parse(JSON.stringify(obj))
    Offer.setClass(copy)   
    return copy
  }


  static instance () {
    return new Offer({
      orgId: '',
      grain: '',
      grade: '',
      season: '',
      pesticideFree: true,
      treatmentDetail: {
        treatedWith: '',
        date: '',
        rate: ''
      },
      storageType: '',
      farmLocation: {
        // streetAddress: '',
        // city: '',
        // state: '',
        // latitude: '',
        // longitude: '',
      },
      state: '',
      region: '',
      farmStorageType: '',
      meetsGTAStandard: true,
      ticketDetail: {
        protein: '',
        moisture: '',
        weight: '',
        screenings: '',
        oil: '',
        variety: '',
      },
      warehouseProvider: '',
      warehouseLocation: '',
      pricingMethod: 'WAREHOUSE_TRANSFER',
      offerType: '',
      orgId: '',
      paymentTerm: '',
      firmOfferExpiry: '7_DAYS',
      price: '',
      quantity: '',
      remainingQuantity: null,
      comment: '',
      isPublic: true,
      nearestTownDistance: null,
      nearestTownDirection: null,
      datePreferredPickupStart: new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      datePreferredPickupEnd: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    })
  }


}
